export default __webpack_public_path__ + "static/media/hot-1.58b87a01.png";